"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const CropsGrid_vue_1 = __importDefault(require("@becrop/components/Common/CropsGrid.vue"));
const WYRSubclients_vue_1 = __importDefault(require("@becrop/components/Common/WYRSubclients.vue"));
const ModalStamp_vue_1 = __importDefault(require("@becrop/components/Common/ModalStamp.vue"));
const bmk_ui_framework_1 = require("@biomemakers/bmk_ui_framework");
const SidebarResult_vue_1 = __importDefault(require("@becrop/components/Results/Layout/SidebarResult.vue"));
const TopbarResult_vue_1 = __importDefault(require("@becrop/components/Results/Layout/TopbarResult.vue"));
const TableReportList_vue_1 = __importDefault(require("./TableReportList.vue"));
const TableSummaryReport_vue_1 = __importDefault(require("@becrop/components/Results/Common/TableSummaryReport.vue"));
const lucide_vue_next_1 = require("lucide-vue-next");
const User_1 = __importDefault(require("@common/models/User"));
const Crop_1 = __importDefault(require("@becrop/components/Results/Abstract/Models/Crop"));
const ReportController_1 = __importDefault(require("@becrop/components/Results/Abstract/Controllers/ReportController"));
const trans_1 = require("@common/tsutils/trans");
let ReportsList = class ReportsList extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.raw_user = null;
        this.user = null;
        this.reportsService = new ReportController_1.default();
        this.currentPageReports = {
            numPage: -1,
            reports: []
        };
        this.samples = [];
        this.criteria = '';
        this.direction = 0;
        this.toastActive = true;
        this.isToastSuccessfulEditionActive = false;
        this.textSearch = '';
        this.theadElements = [
            {
                name: 'ID',
                slug: 'id',
                sortable: true
            },
            {
                name: (0, trans_1.trans)('results.blocks.name_s'),
                slug: 'parcel',
                sortable: true
            },
            {
                name: (0, trans_1.trans)('results.projects.name') + '/' + (0, trans_1.trans)('tracking.proposal'),
                slug: 'projects/proposal',
                sortable: true
            },
            {
                name: (0, trans_1.trans)('results.date'),
                slug: 'date',
                sortable: true
            },
            {
                name: (0, trans_1.trans)('results.tags'),
                slug: 'tags',
                sortable: false
            },
            {
                name: (0, trans_1.trans)('results.summary'),
                slug: 'summary',
                sortable: false
            },
        ];
    }
    get internalTheme() {
        if (this.theme)
            return this.theme;
        return this.$theme.current.value;
    }
    created() {
        if (this.raw_user)
            this.user = User_1.default.fromJson(this.raw_user);
        this.reportsService.populateReports(Object.values(this.becrop_current_samples));
        this.currentPageReports = this.reportsService.paginatedReports[this.reportsService.currentPage - 1];
    }
    get crops() {
        const parsedCrops = Object.values(this.raw_would_rather_crops);
        const myCrops = parsedCrops.map((c) => {
            return new Crop_1.default(c);
        });
        return myCrops;
    }
    get uniqueParcels() {
        const parsedParcels = this.reportsService.allParcels((Object.values(this.parcels)));
        const parsedParcelsArr = parsedParcels.flat().map((p) => p.parcel).filter((np) => np);
        const parsedParcelsArrUnique = [];
        parsedParcelsArr.forEach((p) => {
            if (parsedParcelsArrUnique.findIndex((lp) => lp.id === p.id) === -1) {
                parsedParcelsArrUnique.push(p);
            }
        });
        return parsedParcelsArrUnique;
    }
    get parsedParcels() {
        const parcelsUnique = this.uniqueParcels;
        const parsedParcelsArrSelect = parcelsUnique.map((p) => {
            return {
                'label': p.user_name,
                'value': p.id
            };
        });
        return parsedParcelsArrSelect;
    }
    get distributor() {
        return this.raw_user.client.is_distributor;
    }
    get subClient() {
        return this.raw_user.client.subclients;
    }
    get samplesOnGoing() {
        return this.reportsService.ongoingReports;
    }
    get allValid() {
        if (this.reportsService.orphanReports.length === 0)
            return true;
        return false;
    }
    loadPage(page) {
        //this.reportsService.updatePage(page);
    }
    launchCrumb(name) {
        this.$emit('launchcrumb', name);
    }
    onchangesearch(text) {
        this.textSearch = text;
        this.reportsService.keyToSearch = text;
        this.reportsService.filterReports();
    }
    dismissToast() {
        this.toastActive = false;
    }
    dismissEditionToast() {
        this.isToastSuccessfulEditionActive = false;
    }
    deployEditionToast() {
        this.isToastSuccessfulEditionActive = true;
    }
    notifySuccessfulEdition() {
        this.deployEditionToast();
    }
    updateSortable(newCriteria) {
        const directions = [-1, 0, 1];
        if (newCriteria !== this.criteria) {
            this.criteria = newCriteria;
            this.direction = directions[2];
        }
        else {
            let dirIx = directions.findIndex((d) => d === this.direction);
            dirIx === directions.length - 1 ? (dirIx = 0) : (dirIx = dirIx + 1);
            this.direction = directions[dirIx];
        }
        this.reportsService.orderDirection = this.direction;
        this.reportsService.orderCriteria = this.criteria;
        this.reportsService.orderReports();
    }
    updateReports(rId, pId) {
        const modReportIx = this.reportsService.rawReports.findIndex((r) => r.id === rId);
        const modParcelIx = this.uniqueParcels.findIndex((p) => p.id === pId);
        this.reportsService.rawReports[modReportIx].parcel = this.uniqueParcels[modParcelIx];
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: null })
], ReportsList.prototype, "theme", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)()
], ReportsList.prototype, "filter_list", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)()
], ReportsList.prototype, "raw_would_rather_crops", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)()
], ReportsList.prototype, "becrop_current_samples", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)()
], ReportsList.prototype, "becrop_crops", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)()
], ReportsList.prototype, "parcels", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)()
], ReportsList.prototype, "raw_user", void 0);
ReportsList = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            Highlighter: bmk_ui_framework_1.Highlighter,
            Tag: bmk_ui_framework_1.Tag,
            StandardTemplate: bmk_ui_framework_1.StandardTemplate,
            Yield: bmk_ui_framework_1.Yield,
            SidebarResult: SidebarResult_vue_1.default,
            TopbarResult: TopbarResult_vue_1.default,
            Breadcrumbs: bmk_ui_framework_1.Breadcrumbs,
            HomeIcon: bmk_ui_framework_1.HomeIcon,
            PageHeading: bmk_ui_framework_1.PageHeading,
            TubeIcon: bmk_ui_framework_1.TubeIcon,
            Separator: bmk_ui_framework_1.Separator,
            BreadcrumbsItem: bmk_ui_framework_1.BreadcrumbsItem,
            TableSummaryReport: TableSummaryReport_vue_1.default,
            Toasts: bmk_ui_framework_1.Toasts,
            Info: lucide_vue_next_1.Info,
            TableReportList: TableReportList_vue_1.default,
            Pagination: bmk_ui_framework_1.Pagination,
            Loader: bmk_ui_framework_1.Loader,
            CropsGrid: CropsGrid_vue_1.default,
            WYRSubclients: WYRSubclients_vue_1.default,
            ModalStamp: ModalStamp_vue_1.default,
            WarningDiamondIcon: bmk_ui_framework_1.WarningDiamondIcon,
            CheckRoundedIcon: bmk_ui_framework_1.CheckRoundedIcon
        },
    })
], ReportsList);
exports.default = ReportsList;
